"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const react_1 = require("react");
const react_router_1 = require("react-router");
require("./requestDemoForm.less");
const lexico = new lexico_1.default();
let wasScriptRun = false;
const RequestDemoForm = () => {
    const [isRequestDemoFormLoaded, setIsRequestDemoFormLoaded] = (0, react_1.useState)(false);
    const navigate = (0, react_router_1.useNavigate)();
    const [searchParams] = (0, react_router_1.useSearchParams)();
    (0, react_1.useEffect)(() => {
        if (searchParams.get('completed') === 'true') {
            void navigate('/signin/message', {
                state: {
                    heading: lexico.tr('We’ll be in touch!'),
                    message: lexico.tr('A member of our customer success team will reach out to you shortly.'),
                },
            });
        }
        if (wasScriptRun) {
            wasScriptRun = false;
        }
        else {
            wasScriptRun = true;
            globalThis.MktoForms2?.loadForm('//marketing.tradeshift.com', '213-SPR-003', 9785);
            globalThis.MktoForms2?.whenReady(() => {
                setIsRequestDemoFormLoaded(true);
            });
        }
    }, [navigate, searchParams]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { className: "request-demo-loading", style: { display: isRequestDemoFormLoaded ? 'none' : 'block' }, children: [(0, jsx_runtime_1.jsx)("span", { children: lexico.tr('Loading...') }), (0, jsx_runtime_1.jsx)("button", { className: "ts-primary", disabled: !isRequestDemoFormLoaded })] }), (0, jsx_runtime_1.jsx)("form", { id: "mktoForm_9785", style: { display: isRequestDemoFormLoaded ? 'block' : 'none' } })] }));
};
exports.default = RequestDemoForm;
